import { inject, Injectable } from '@angular/core';
import { ApolloService } from '@services/apollo/apollo.service';
import { environment } from 'src/environments/environment';
import { getSupportAdminSettingPage } from '../graphql/support-admin-data-page.query';

@Injectable({
  providedIn: 'root',
})
export class PrevailingWageSetupService {
  serverName: string = environment.graphql.wagedata.name;
  private readonly apolloService = inject(ApolloService);

  getSupportAdminSettingPageData(tenantId: string): any {
    const vars = { tenantId };
    return this.apolloService.query(
      this.serverName,
      getSupportAdminSettingPage,
      vars
    );
  }
}
